import {
  StaffContactDetailsDto,
  StaffRoleType,
  StaffSubordinatesHierarchiesServiceProxy,
} from '@shared/service-proxies/service-proxies';
import {
  PersonnelsServiceProxy,
  PersonnelHoursGraphDto,
  AllocationSheetStatus,
} from './../../../../../../shared/service-proxies/service-proxies';
import { Component, ViewChild } from '@angular/core';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { DashboardChartBase } from '../dashboard-chart-base';
import { Subject } from 'rxjs/internal/Subject';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-widget-personnel-graph',
  templateUrl: './widget-personnel-graph.component.html',
  styleUrls: ['./widget-personnel-graph.component.scss'],
})
export class WidgetPersonnelGraphComponent extends DashboardChartBase {
  personnelHours: PersonnelHoursGraphDto[];
  staffs: StaffContactDetailsDto[];
  chartData: any[] = [];
  scheme: any = {
    domain: ['#34bfa3', '#EEF0F8'],
  };
  showXAxis: boolean = true;
  @ViewChild('managerSelector', { static: true }) managerSelector: MatSelect;
  public managerFormCtrl: FormControl = new FormControl();
  public nameFormCtrl: FormControl = new FormControl();
  managers: StaffContactDetailsDto[];
  names: StaffContactDetailsDto[];
  protected _onDestroy = new Subject<void>();
  constructor(
    private _personnelsService: PersonnelsServiceProxy,
    private _staffSubordinatesHierarchiesService: StaffSubordinatesHierarchiesServiceProxy,
    private _projectService: ProjectService
  ) {
    super();
  }
  groupBy<T>(arr: T[], fn: (item: T) => any) {
    return arr.reduce<Record<string, T[]>>((prev, curr) => {
      const groupKey = fn(curr);
      const group = prev[groupKey] || [];
      group.push(curr);
      return { ...prev, [groupKey]: group };
    }, {});
  }
  // Observable for update
  update$: Subject<any> = new Subject();

  // Update function
  updateChart() {
    this.update$.next(true);
  }

  async load() {
    this.showLoading();
    let [personnelHours, staffs] = await Promise.all([
      this.getPersonnelHours(),
      this.staffSubordinatesHierarchies(),
    ]);

    this.personnelHours = personnelHours;
    this.staffs = staffs;
    this.managers = this.staffs.filter(
      (s) => s.staffRole == StaffRoleType.Foreman
    );
    this.names = this.staffs.filter(
      (s) => s.staffRole == StaffRoleType.Supervisor
    );
    this.setChartData([],[]);
  }

  async getPersonnelHours() {
    var personnelHours = await this._personnelsService
      .getPersonnelHoursForGraphByProject()
      .toPromise()
      .then((result) => {
        return result.personnelHours;
      });
    return personnelHours;
  }

  async staffSubordinatesHierarchies() {
    var staffs = await this._staffSubordinatesHierarchiesService
      .getAllStaffsInByProjectAndStaffRole([
        StaffRoleType.Foreman,
        StaffRoleType.Supervisor,
      ])
      .toPromise()
      .then((result) => {
        return result.staffs;
      });
    return staffs;
  }

  setChartData(createrIds: number[], signOffIds: number[]) {
    var filteredHours = this.personnelHours;
    if (createrIds.length > 0) {
      filteredHours = filteredHours.filter((f) => createrIds.some(c=> c == f.creatorId));
    }

    if (signOffIds.length > 0) {
      filteredHours = filteredHours.filter((f) => signOffIds.some(c=> c == f.signoffId));
    }

    let hours = this.groupBy(filteredHours, (e) => {
      return e.workDay.format('DD-MM-YYYY');
    });
    var chartData = [];
    Object.entries(hours).forEach((element) => {
      chartData.push({
        name: element[0],
        series: [
          {
            day: element[0],
            name: 'Hours approved by Admin',
            value: element[1]
              .filter(
                (h) => h.status == AllocationSheetStatus.ApprovedByProjectAdmin
              )
              .reduce(function (a, b) {
                return a + b.actualHours;
              }, 0),
          },
          {
            day: element[0],
            name: 'Hours to be submitted',
            value: element[1]
              .filter(
                (h) => h.status !== AllocationSheetStatus.ApprovedByProjectAdmin
              )
              .reduce(function (a, b) {
                return a + b.actualHours;
              }, 0),
          },
        ],
      });
    });
    this.chartData = [...chartData];
  }

  selectedManager(event: any) {
    this.setChartData([], event.value);
  }

  selectedName(event: any) {
    this.setChartData(event.value, []);
  }

  ngOnInit() {
    this.load();
  }
}
